const DynamicOptionType = Object.freeze({
	regular: 1,
	additionalParameter: 2,
	autocomplete: 3,
	variable: 4,
	conditions: 5,
	valueWithOperator: 6
});
export default DynamicOptionType;
